<template>
	<div>

		<div class="r-title">
			<img src="../../assets/imgs/news/news-title-bg.png" class="r-title-bg">
			<span style="z-index: 1;position: relative;">Demand Customization</span>
		</div>

		<div>
			<div class="df type">
				<el-button @click="change(index)" :key="index" :class="{active:current==index}"
					v-for="(item,index) in ['Pending review','in progress','closed','Review failed']">{{item}}</el-button>
			</div>
			<div class="df fdc wow fadeInUp animated">
				<div class="items hover-up transition-normal fadeIn" v-for="(item, index2) in data" :key="index2"
					@click="$router.push({name: 'demandDetails',query:{id:item.id}})">
					<div class="df aic" v-if="item.user">
						<img class="avatar" style="width: 30px;height: 30px;margin-right: 0.5rem;" :src="item.user.avatar" alt="" />
						<div class="user-name" v-text="item.user.username"></div>
					</div>
					<div class="title">{{item.title}}</div>
					<div class="subTitle text_over_2line">{{item.sub_title}}</div>
					<div class="df jcfe" style="margin-top: 1rem;">
						<el-button v-if="current==1" @click.stop="status(item.id,3)">close</el-button>
						<el-button v-if="current==2" @click.stop="status(item.id,2)">open</el-button>
						<el-button v-if="current==3" @click.stop="$router.push({name: 'productCustomize',query:{id:item.id}})">edit</el-button>
					</div>
				</div>
				<div v-show="data.length==0&&!loading" class="nodata-box">
					<img src="../../assets/imgs/nodata.svg" class="nodata-img">
				</div>
			</div>
		</div>
		<pagination :pageSizeList="[]" :page="params.page" :page-size="params.perPage" :total="nowtotal||0"
			:on-page-change="onPage" class="pagi page-content" />
	</div>
</template>

<script>
	import Pagination from '@/components/pagination.vue';
	export default {
		data() {
			return {
				data: [],
				loading: true,
				current: 0,
				nowtotal: 0,
				params: {
					perPage: 6,
					page: 1,
					status: 1
				}
			}
		},
		components: {
			Pagination,
		},
		methods: {
			async status(id,status){
				let res=await this.$post(`/gci/product/custom/${id}/edit`,{
					status
				})
				this.getdata();
				this.$bus.$emit('message', {
					type: 2,
					msg: res.msg
				})
			},
			// 分页
			onPage(pageNow) {
				this.params.page = pageNow;
				window.scrollTo(0, 0);
				this.getdata()
			},
			change(index) {
				this.current = index
				this.params.status = ++index;
				this.getdata()
			},
			async getdata() {
				this.loading = true
				let {
					data
				} = await this.$get('/gci/product/my_customs', this.params)
				this.data = data.items
				this.nowtotal = data.total
				this.loading = false
			}
		},
		mounted() {
			this.getdata()
		}
	}
</script>

<style lang="scss" scoped>
	@media (max-width:767px) {
		.type{
			overflow-x: scroll;
		}
	}
	.el-button:hover {
		background-color: #00E8BE;
	}
	.active {
		background-color: #00E8BE;
		color: #000;
	}

	.items {
		cursor: pointer;
		overflow: hidden;
		padding: 1rem;
		margin-top: 1rem;
		border-radius: 0.5rem;
		border: 1px solid #e8e8e8;
	}

	.r-title {
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		position: relative;

		.r-title-bg {
			width: 13rem;
			position: absolute;
			left: -0.5rem;
			top: -2rem
		}
	}

	.title {
		margin: 0.5rem 0;
		font-size: 20px;
		font-weight: bold;
	}

	.avatar {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 50%;
	}
</style>